import { h, FunctionalComponent } from 'preact';
import style from './wrapper.scss';

export const Wrapper: FunctionalComponent = ({ children }) => {
  return <div class={style.wrapperDiv}>{children}</div>;
};
